import React, {useEffect, useState} from 'react';
import {
    Cell,
    List,
    Section,
    Input,
    Select,
    Button,
    Textarea,
    ButtonCell,
    Blockquote,
    FileInput,
    Image, Caption, Placeholder, Spinner
} from '@telegram-apps/telegram-ui';
import {FaCheckCircle} from "react-icons/fa";
import {FcCheckmark, FcOk,} from "react-icons/fc";
import toast from "react-hot-toast";
import {useLocation, useNavigate} from "react-router-dom";
import {get_city_list_api, get_district_list_api, get_parent_id_api, get_province_list_api} from "../api/AreaAPI";
import {submit_teacher_api} from "../api/UserAPI";
import InfoFooter from "../component/InfoFooter";
import {TbHomeDot} from "react-icons/tb";
import WebApp from "@twa-dev/sdk";


function TeacherCreator() {
    const navigate = useNavigate()
    const {state} = useLocation();
    //编辑模式1->普通新增模式 2->管理员新增模式
    const [editType, setEditType] = useState(0)
    //网络状态 模式：0->填写 1->上传中 2->上传完成
    const [uploadingState, setUploadingState] = useState(0)
    const [imgList, setImgList] = useState([] as ImageEntity[])
    //茶艺师信息对象
    const [teacherName, setTeacherName] = useState("")
    const [teacherAge, setTeacherAge] = useState(30)
    const [teacherPriceVideo, setTeacherPriceVideo] = useState(0)
    const [teacherPriceEasy, setTeacherPriceEasy] = useState(0)
    const [teacherPriceNormal, setTeacherPriceNormal] = useState(0)
    const [teacherPriceTwo, setTeacherPriceTwo] = useState(0)
    const [teacherPriceNight, setTeacherPriceNight] = useState(0)
    const [teacherConnect, setTeacherConnect] = useState([] as ConnectEntity[])
    const [selectProvince, setSelectProvince] = useState(0)
    const [selectCity, setSelectCity] = useState(0)
    const [selectDistrict, setSelectDistrict] = useState(0)
    const [teacherTown, setTeacherTown] = useState("未知")
    const [teacherAddress, setTeacherAddress] = useState("具体位置未知")
    const [teacherRemark, setTeacherRemark] = useState("")
    const [teacherType, setTeacherType] = useState(1)
    const [insertConnectType, setInsertConnectType] = useState("Wechat")
    const [insertConnectContent, setInsertConnectContent] = useState("")
    const [provinceList, setProvinceList] = useState([] as ResponseAreaNodeEntity[])
    const [cityList, setCityList] = useState([] as ResponseAreaNodeEntity[])
    const [districtList, setDistrictList] = useState([] as ResponseAreaNodeEntity[])
    const [onSubmitSuccessStr, setOnSubmitSuccessStr] = useState("感谢您的贡献，请等待管理员审核！")

    useEffect(() => {
        setEditType(state.type)
        const userStr = sessionStorage.getItem("User");
        if (userStr == null) {
            toast.error("获取用户名失败，请重试")
            navigate('/Fake', {replace: false})
            return
        }
        const userParse: ResponseUserEntity = JSON.parse(userStr)
        loadProvinceList(userParse)
    }, [])
    const loadProvinceList = (user: ResponseUserEntity) => {
        get_province_list_api()
            .then((res) => {
                setProvinceList(res.data.data)
                setSelectProvince(res.data.data[0].area_id)
                get_parent_id_api({request_area_id: user.city_id} as RequestAreaEntity)
                    .then((res) => {
                        loadCityList(res.data.data)
                    })
            })
    }
    const loadCityList = (provinceVal: number) => {
        setSelectProvince(provinceVal)
        get_city_list_api({request_area_id: provinceVal} as RequestAreaEntity)
            .then((res) => {
                setCityList(res.data.data)
                setSelectCity(res.data.data[0].area_id)
                loadDistrictList(res.data.data[0].area_id)
            })
    }
    const loadDistrictList = (cityVal: number) => {
        setSelectCity(cityVal)
        get_district_list_api({request_area_id: cityVal} as RequestAreaEntity)
            .then((res) => {
                setDistrictList(res.data.data)
                setSelectDistrict(res.data.data[0].area_id)
            })
    }
    const onImgUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.currentTarget.files == null || event.currentTarget.files.length <= 0) {
            toast.error("图片上传失败")
            return
        }
        let imageFile = event.currentTarget.files[0];///获得input的第一个图片
        if (imageFile.size > (1024 * 5 * 1000)) {
            toast.error("文件大于5MB，请重新上传")
            return;
        }
        //使用readAsDataURL来进行回显图片
        let reader = new FileReader();//filereader.readasdataurl读取图像文件转换为流
        reader.readAsDataURL(imageFile);
        reader.onload = function (event) {//读取数据时会触发一个load事件
            let imageStr = this.result as string
            if ((imageStr.length / 1024 / 1024) >= 5) {
                toast.error("文件大于5MB，请重新上传")
                return;
            }
            imgList.push({name: imageFile.name, size: imageFile.size / 1024 / 1024, data: imageStr} as ImageEntity)
            let imgListCopy = [] as ImageEntity[]
            Object.assign(imgListCopy, imgList)
            setImgList(imgListCopy)
        };
    }
    const onInsertConnectBtnClick = () => {
        if (insertConnectContent === "") {
            toast.error("新增联系方式不能为空")
            return
        }
        let connectItem = {type: insertConnectType, value: insertConnectContent} as ConnectEntity
        let connectListCopy = [] as ConnectEntity[]
        Object.assign(connectListCopy, teacherConnect)
        connectListCopy.push(connectItem)
        setTeacherConnect(connectListCopy)
        toast.success("新增" + transformConnect(connectItem.type) + "成功")
        setInsertConnectContent("")
    }
    const onDeleteImgBtnClick = (index: number) => {
        WebApp.showConfirm("确定删除这项吗？", (r) => {
            if (r === false) {
                return
            }
            let imgListCopy = [] as ImageEntity[]
            for (let i = 0; i < imgList.length; i++) {
                if (i !== index) {
                    imgListCopy.push(imgList[i])
                } else {
                    toast.success("已删除：" + imgList[i].name)
                }
            }
            setImgList(imgListCopy)
        })
    }
    const onDeleteConnectBtnClick = (index: number) => {
        WebApp.showConfirm("确定删除这项吗？", (r) => {
            if (r === false) {
                return
            }
            let connectListCopy = [] as ConnectEntity[]
            for (let i = 0; i < teacherConnect.length; i++) {
                if (i !== index) {
                    connectListCopy.push(teacherConnect[i])
                } else {
                    toast.success("已删除：" + teacherConnect[i].value)
                }
            }
            setTeacherConnect(connectListCopy)
        })
    }
    const onSubmitBtnClick = () => {
        if (teacherName === "") return toast.error("茶艺师名称不能为空")
        if (teacherAge === 0) return toast.error("茶艺师年龄不能为空")
        if (teacherTown === "") return toast.error("茶艺师大地名不能为空")
        if (teacherAddress === "") return toast.error("茶艺师详细地址不能为空")
        if (teacherRemark === "") return toast.error("茶艺师备注不能为空")
        if (teacherPriceVideo === 0 && teacherPriceEasy === 0 && teacherPriceNormal === 0 && teacherPriceTwo === 0 && teacherPriceNight === 0) return toast.error("至少添加一项服务价格")
        if (teacherConnect.length === 0) return toast.error("至少添加一项联系方式")
        if (imgList.length === 0) return toast.error("至少添加一张展示图片")
        let teacher_entity: RequestTeacherEntity = {} as RequestTeacherEntity
        teacher_entity.name = teacherName
        teacher_entity.age = teacherAge
        teacher_entity.type = teacherType
        teacher_entity.city = selectCity
        teacher_entity.district = selectDistrict
        teacher_entity.town = teacherTown
        teacher_entity.address = teacherAddress
        teacher_entity.remark = teacherRemark

        teacher_entity.price_video = teacherPriceVideo
        teacher_entity.price_easy = teacherPriceEasy
        teacher_entity.price_normal = teacherPriceNormal
        teacher_entity.price_two = teacherPriceTwo
        teacher_entity.price_night = teacherPriceNight

        teacher_entity.connect = JSON.stringify(teacherConnect);
        let teacher_image_list: string[] = []
        for (const imageEntity of imgList) {
            teacher_image_list.push(imageEntity.data)
        }
        setUploadingState(1)
        submit_teacher_api({
            teacher_entity: teacher_entity,
            teacher_image_list: teacher_image_list
        } as RequestNewTeacherEntity).then(res => {
            toast.success(res.data.message)
            setOnSubmitSuccessStr(res.data.message)
            setUploadingState(2)
        })
    }
    const transformConnect = (type: string) => {
        switch (type) {
            case "Phone":
                return "联系电话"
            case "Tencent":
                return "QQ号"
            case "Wechat":
                return "微信号"
            case "Telegram":
                return "电报链接"
            case "Potato":
                return "土豆号"
            case "Bat":
                return "蝙蝠号"
            case "WithYou":
                return "与你号"
        }
    }
    return (
        <List style={{minHeight: WebApp.viewportStableHeight}}>
            {uploadingState === 0 &&
                <div>
                    <Cell>
                        <Blockquote type="text" style={{whiteSpace: "pre-wrap", backgroundColor: "#2990FF33"}}>
                            {editType === 0 && "亲爱的用户：\n    非常感谢您为平台献出一份力。\n    为保证茶艺师的真实性，本平台以“用户提交+管理审核”的模式，尽可能避免用户上当受骗。\n    故此，填报过程略微有些繁琐，请您耐心填写以下内容并提交。\n    等待管理员审核通过后，将给予您大量积分奖励！\n    品茗团队对您表示由衷的感谢！"}
                            {editType === 1 && "管理员须知：\n    若您新增的茶艺师为您的管理区域，将跳过审核阶段，你可以在已验证中查看或修改。\n    审核修改资料时，务必确认后再点击！"}
                        </Blockquote>
                    </Cell>
                    <Section header="🥻基础信息"
                             footer="本部分均为必填项，请仔细核对后填写。大地名/位置未知的情况请填写[未知]">
                        <Input header="茶艺师名称" placeholder="茶艺师名称 例如：小猫"
                               value={teacherName}
                               onChange={e => setTeacherName(e.target.value)}/>
                        <Input before={<Caption weight="3" style={{width: 40}}> 年龄 </Caption>}
                               header="年龄" placeholder="年龄 岁" type="number"
                               value={teacherAge}
                               onChange={e => setTeacherAge(Number(e.target.value))}/>
                        <Select header="类型"
                                value={teacherType}
                                onChange={e => setTeacherType(Number(e.target.value))}>
                            <option value={1}>全职，通常自带品茶房间</option>
                            <option value={2}>兼职，另需用户预约房间</option>
                        </Select>
                        <Select header="所在省级城市" value={selectProvince}
                                onChange={e => loadCityList(Number(e.target.value))}>
                            {provinceList.map(item => <option value={item.area_id}>{item.name}</option>)}
                        </Select>
                        <Select header="所在市级城市" value={selectCity}
                                onChange={e => loadDistrictList(Number(e.target.value))}>
                            {cityList.map(item => <option value={item.area_id}>{item.name}</option>)}
                        </Select>
                        <Select header="所在区级城市" value={selectDistrict}
                                onChange={e => setSelectDistrict(Number(e.target.value))}>
                            {districtList.map(item => <option value={item.area_id}>{item.name}</option>)}
                        </Select>
                        <Input before={<Caption weight="3" style={{width: 40}}> 地名 </Caption>}
                               header="稍大地名" placeholder="稍大地名 例如：时代天街"
                               value={teacherTown}
                               onChange={e => setTeacherTown(e.target.value)}/>
                        <Input before={<Caption weight="3" style={{width: 40}}> 位置 </Caption>}
                               header="精确位置" placeholder="精确位置 例如：xx小区"
                               value={teacherAddress}
                               onChange={e => setTeacherAddress(e.target.value)}/>
                        <Textarea style={{minHeight: "150px"}}
                                  header="基本介绍" placeholder="基本介绍 例如：该老师服务态度好，很体贴细心等..."
                                  value={teacherRemark}
                                  onChange={e => setTeacherRemark(e.target.value)}/>
                    </Section>
                    <Section header="👑️服务价格" footer="提示：至少需要填写一种价格。如某项目价格未知，请留空或填0">
                        <Input before={<Caption weight="3" style={{width: 80}}> 视频指导 </Caption>}
                               header="视频/图片价格" placeholder="视频/图片价格" type="number"
                               value={(teacherPriceVideo === 0 ? undefined : teacherPriceVideo)}
                               onChange={e => setTeacherPriceVideo(Number(e.target.value))}/>
                        <Input before={<Caption weight="3" style={{width: 80}}> 基础指导 </Caption>}
                               header="基础服务"
                               placeholder="基础服务 价格" type="number"
                               value={(teacherPriceEasy === 0 ? undefined : teacherPriceEasy)}
                               onChange={e => setTeacherPriceEasy(Number(e.target.value))}/>
                        <Input before={<Caption weight="3" style={{width: 80}}> 全套指导 </Caption>}
                               header="全套服务" placeholder="全套服务 价格" type="number"
                               value={(teacherPriceNormal === 0 ? undefined : teacherPriceNormal)}
                               onChange={e => setTeacherPriceNormal(Number(e.target.value))}/>
                        <Input before={<Caption weight="3" style={{width: 80}}> 两次指导 </Caption>}
                               header="两次服务" placeholder="两次服务 价格" type="number"
                               value={(teacherPriceTwo === 0 ? undefined : teacherPriceTwo)}
                               onChange={e => setTeacherPriceTwo(Number(e.target.value))}/>
                        <Input before={<Caption weight="3" style={{width: 80}}> 包时指导 </Caption>}
                               header="包时服务" placeholder="包时服务 价格" type="number"
                               value={(teacherPriceNight === 0 ? undefined : teacherPriceNight)}
                               onChange={e => setTeacherPriceNight(Number(e.target.value))}/>
                    </Section>
                    <Section header="📲联系方式"
                             footer="若要编辑某项联系方式,请复制后重新添加，待添加完成后再移除旧的项目。电报链接请直接设置用户@XXX部分">
                        {
                            teacherConnect.map((item, index) =>
                                <Cell after={<Button mode="filled" size="s"
                                                     onClick={() => onDeleteConnectBtnClick(index)}
                                > 移除 </Button>}
                                      description={transformConnect(item.type)}
                                > {item.value} </Cell>
                            )
                        }
                        <Input header="新增联系方式" placeholder="新增联系方式内容" value={insertConnectContent}
                               onChange={e => setInsertConnectContent(e.target.value)}/>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            minHeight: "60px"
                        }}>
                            <Select header="类型" defaultValue={insertConnectType}
                                    onChange={e => setInsertConnectType(e.target.value)}>
                                <option value={"Phone"}>联系电话</option>
                                <option value={"Tencent"}>QQ号</option>
                                <option value={"Wechat"}>微信号</option>
                                <option value={"Telegram"}>电报链接</option>
                                <option value={"Potato"}>土豆号</option>
                                <option value={"Bat"}>蝙蝠号</option>
                                <option value={"WithYou"}>与你号</option>
                            </Select>
                            <Button style={{marginRight: "18px"}}
                                    before={<FaCheckCircle/>}
                                    mode="filled"
                                    size="s"
                                    onClick={e => {
                                        onInsertConnectBtnClick()
                                    }}
                            >点击添加</Button>
                        </div>
                    </Section>
                    <Section header="🎥展示图片" footer="目前仅支持上传图片，且单张图片不超过5MB">
                        {
                            imgList.map((img, index) =>
                                <Cell before={<Image size={96} src={img.data}/>}
                                      after={<Button mode="filled" size="s"
                                                     onClick={() => onDeleteImgBtnClick(index)}
                                      > 移除 </Button>}
                                      multiline
                                      style={{minHeight: 112}}
                                      description={img.size.toFixed(2) + "MB"}
                                > {img.name}
                                </Cell>
                            )
                        }
                        <Cell>
                            <FileInput accept="image/jpeg,image/jpg,image/png"
                                       onChange={e => onImgUpload(e)}
                                       label="点击上传图片"
                            />
                        </Cell>
                    </Section>
                    <Section header="📑️确认您的修改" footer="请认真检查填写内容，如有问题请勿盲目修改">
                        <ButtonCell before={<FcCheckmark size={20}/>} onClick={e => {
                            onSubmitBtnClick()
                        }}>
                            确认以上所有修改并保存
                        </ButtonCell>
                    </Section>
                </div>
            }
            {uploadingState === 1 &&
                <div>
                    <Placeholder
                        header="正在上传中"
                        description="请稍后，请勿退出或切换应用..."
                    >
                        <Spinner size="l"/>
                    </Placeholder>
                </div>
            }
            {uploadingState === 2 &&
                <div>
                    <Placeholder
                        description={
                            <div style={{display: "flex", flexDirection: "column", rowGap: 20}}>
                                {onSubmitSuccessStr}
                                <Button
                                    before={<TbHomeDot size={24}/>}
                                    mode="filled"
                                    size="s"
                                    onClick={() => {
                                        navigate(-1)
                                    }}
                                >返回至上一层
                                </Button>
                            </div>
                        }
                        header="提交成功">
                        <FcOk size={64}/>
                    </Placeholder>
                </div>
            }
            <InfoFooter/>
        </List>
    );
}

export default TeacherCreator;
